export enum CustomMessageType {
    /**商品卡片 */
    GOODS = 'SEND_GOODS_MESSAGE',
    /**订单消息 */
    ORDER = 'SEND_ORDER_MESSAGE',
    /**自动回复关键词消息 */
    AUTO_REPLY = 'SEND_SERVICE_GREET',
    /** 系统自定义消息 */
    SYSTEM = 'HU_CUSTOM_SYSTEM_MESSAGE',
    /** 排队消息 */
    QUEUE = 'USER_QUEUE_MSG',
    /** 预售后 */
    ORDER_RETURN_PRE_CREATE = 'ORDER_RETURN_PRE_CREATE',
    /** 客服创建售后单 */
    ORDER_RETURN_CUSTOMER_CREATE = 'ORDER_RETURN_CUSTOMER_CREATE',
    /** ai回复图文 */
    AI_REPLY_IMG_MSG = 'AI_REPLY_IMG_MSG',
    /** 客户转接提示消息 */
    CUSTOMER_EXCHANGE = 'IM_CUSTOMER_EXCHANGE_MSG'
}
